import { InsurancePolicyType } from "@wingspanhq/wingspan-api-sdk";
import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { OAI_KEY, PLAN_DETAILS } from "../../Benefits/utils/constants";

type IPlanType = planEnrollmentApiSpec.PlanEnrollment["planType"];

export const selectorPolicyNameByPolicyType = (
  policyType: InsurancePolicyType | undefined,
  planType: IPlanType
): string => {
  const names: Partial<Record<InsurancePolicyType, string>> = {
    [InsurancePolicyType.OCCUPATIONAL_ACCIDENT]: PLAN_DETAILS[OAI_KEY].name,
    [InsurancePolicyType.GENERAL_LIABILITY]:
      "Wingspan Professional & General Liability Insurance (GL)",
    [InsurancePolicyType.PROFESSIONAL_LIABILITY]:
      "Wingspan Professional & General Liability Insurance (PL)"
  };

  return (policyType && names[policyType]) || "Insurance coverage";
};
